import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { CrntElement } from '../../lib/crnt-element.js';
import { trustedCSS } from '../../lib/css/css.js';
import proseStyles from './prose.css.js';

var __defProp = Object.defineProperty;
var __decorateClass = (decorators, target, key, kind) => {
  var result = void 0 ;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (decorator(target, key, result) ) || result;
  if (result) __defProp(target, key, result);
  return result;
};
class CrntProse extends CrntElement {
  constructor() {
    super(...arguments);
    this.variant = "expressive";
  }
  static {
    this.styles = trustedCSS(proseStyles);
  }
  static {
    this.tagName = "crnt-prose";
  }
  render() {
    return html`<slot></slot>`;
  }
}
__decorateClass([
  property({ reflect: true })
], CrntProse.prototype, "variant");

export { CrntProse };
